import { SymbolDetails } from '../../../../types/symbol.types';
import { SpotAccountData } from '../../../../types/funds.types';

interface MarketOrderFormProps {
  tradeType: 'buy' | 'sell';
  baseCurrency: string;
  quoteCurrency: string;
  symbolDetails: SymbolDetails | null;
  accountBalance: SpotAccountData | null;
  availableQty: string;
  orderValue: string;
  sliderPercentage: number;
  errors: {
    price?: string;
    quantity?: string;
    orderValue?: string;
    insufficientBalance?: string;
  };
  setOrderValue: (value: string) => void;
  setSliderPercentage: (value: number) => void;
  setErrors: (errors: any) => void;
  handleOrderValueChange: (value: string) => void;
  handleSliderChange: (value: number) => void;
  validateOrderValue: (value: string) => string | undefined;
  MIN_PRICE_ORDER_IN_USD: number;
  ORDER_VALUE_PRECISION: number;
}

const MarketOrderForm = ({
  tradeType,
  baseCurrency,
  quoteCurrency,
  symbolDetails,
  accountBalance,
  availableQty,
  orderValue,
  sliderPercentage,
  errors,
  setOrderValue,
  setSliderPercentage,
  setErrors,
  handleOrderValueChange,
  handleSliderChange,
  validateOrderValue,
  MIN_PRICE_ORDER_IN_USD,
  ORDER_VALUE_PRECISION
}: MarketOrderFormProps) => {
  return (
    <>
      {/* Price Input - Market Mode: Show "Best Available Price" */}
      <div className="relative">
        <label className="text-f12 text-gray-400">Price</label>
        <div className="w-full dark:bg-black dark:text-white  text-sm rounded px-3 py-2 mt-1 outline-none border border-gray-600 cursor-not-allowed">
          Best Available Price
        </div>
        <div className="text-f12 dark:text-white mt-1 absolute bottom-[7px] right-3">
          {quoteCurrency}
        </div>
      </div>

      {/* Slider */}
      <div className="flex items-center space-x-2 text-f12 text-gray-400">
        <span>0</span>
        <input
          type="range"
          min="0"
          max="100"
          value={sliderPercentage}
          onChange={(e) => handleSliderChange(parseInt(e.target.value))}
          className="w-full cursor-pointer  outline-none appearance-none value-slider"
        />
        <span>100%</span>
      </div>

      {/* Order Value - Market Mode: Show correct currency based on buy/sell */}
      <div className="relative">
        <label className="text-f12 text-gray-400">Order Value</label>
        <div className="text-f12 text-white absolute bottom-[28px] right-3">
          {tradeType === 'buy' ? quoteCurrency : baseCurrency}
        </div>
        <input
          type="text"
          value={orderValue}
          onChange={(e) => handleOrderValueChange(e.target.value)}
          className={`w-full dark:bg-black dark:text-white  text-sm rounded px-3 py-2 mt-1 outline-none border border-red-500
             ${errors.orderValue ? 'border-red-500' : orderValue && parseFloat(orderValue) > 0 ? 'border-gray-600' : 'border-transparent'} !border-[#ff0000]`}
          placeholder="0"
        />
        <div className="text-f12 text-gray-400 mt-1">
          Min: {tradeType === 'buy' 
            ? (symbolDetails?.minFunds || MIN_PRICE_ORDER_IN_USD) 
            : (symbolDetails?.baseMinSize || '0.00001')
          } {tradeType === 'buy' ? quoteCurrency : baseCurrency}
        </div>
      </div>
      {errors.orderValue && (
        <div className="text-red-500 text-f12 mt-1">{errors.orderValue}</div>
      )}
    </>
  );
};

export default MarketOrderForm;
